/**
 * Error code that may occur during WalletAPI server communication
 * @enum
 */
export var RpcErrorCode;
(function (RpcErrorCode) {
    /**
     * Invalid JSON was received by the server.
     * or An error occurred on the server while parsing the JSON text.
     */
    RpcErrorCode[RpcErrorCode["PARSE_ERROR"] = -32700] = "PARSE_ERROR";
    /**
     * The JSON sent is not a valid Request object.
     */
    RpcErrorCode[RpcErrorCode["INVALID_REQUEST"] = -32600] = "INVALID_REQUEST";
    /**
     * The method does not exist / is not available.
     */
    RpcErrorCode[RpcErrorCode["METHOD_NOT_FOUND"] = -32601] = "METHOD_NOT_FOUND";
    /**
     * Invalid method parameter(s).
     */
    RpcErrorCode[RpcErrorCode["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
    /**
     * Internal JSON-RPC error.
     */
    RpcErrorCode[RpcErrorCode["INTERNAL_ERROR"] = -32603] = "INTERNAL_ERROR";
    /**
     * Reserved for implementation-defined server-errors.
     */
    RpcErrorCode[RpcErrorCode["SERVER_ERROR"] = -32000] = "SERVER_ERROR";
})(RpcErrorCode || (RpcErrorCode = {}));
//# sourceMappingURL=types.js.map